import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ClosecodeIcon } from "../common/ClosecodeIcon";

export function Hero() {
  const { t } = useTranslation();

  return (
    <section className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 py-20">
      <div className="max-w-6xl mx-auto text-center">
        <div className="mb-8 flex justify-center">
          <ClosecodeIcon size={80} />
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-warm-50 mb-6 leading-tight">
          <span className="block bg-gradient-to-r from-orange-400 via-pink-500 to-purple-500 bg-clip-text text-transparent pb-2">
            CloseCode
          </span>
          {t("home.hero.title")}
        </h1>

        <p className="text-lg md:text-xl text-warm-400 mb-10 max-w-2xl mx-auto leading-relaxed">
          {t("home.hero.subtitle")}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <Link
            to="/downloads"
            className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 via-pink-500 to-purple-500 text-white font-semibold px-8 py-4 rounded-lg hover:opacity-90 transition-opacity shadow-lg shadow-pink-500/25"
          >
            {t("home.hero.cta.download")}
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
          </Link>

          <Link
            to="/docs"
            className="inline-flex items-center justify-center gap-2 bg-dark-card border border-dark-border text-warm-100 font-semibold px-8 py-4 rounded-lg hover:border-warm-600 hover:text-warm-50 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
              />
            </svg>
            {t("home.hero.cta.docs")}
          </Link>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 via-purple-500/10 to-pink-500/10 rounded-2xl blur-3xl" />
          <div className="relative">
            <img
              src="/images/ade/ade-overview.png"
              alt="CloseCode workspace overview"
              className="w-full rounded-xl border border-dark-border shadow-2xl shadow-black/50"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
